import { render, staticRenderFns } from "./IikoHooks.vue?vue&type=template&id=d1372ce6"
import script from "./IikoHooks.vue?vue&type=script&lang=js"
export * from "./IikoHooks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports